import React from "react";
import FillTemplateProgressIndicator from "./fill_template_modal_content/FillTemplateProgressIndicator";
import { connect } from "react-redux";
import { getCurrentStoreData } from "../../store/websites/thunks";
import { GetCurrentStoreData, WebsitesState } from "../../store/websites/types";
import { WebsitePagesState } from "../../store/websitePages/types";
import { getCurrentPageId } from "../../helpers/getCurrentPageId";
import { getPageLoadStatus } from "../../store/websitePages/thunks";
import { LoadStatus } from "../../enums/enums";
import { Tooltip } from "antd";
import { Copy, CornerUpRight, Settings, Trash2 } from "lucide-react";
import { setSettingsModalType } from "../../store/websites/actions";
import { setIsSettingsModalVisible } from "../../store/user/actions";
import LoaderAnimated from "./LoaderAnimated";
import classNames from "classnames";

interface Props {
  isHidden?: boolean;
  isButtonHidden?: boolean;
  buttons: React.ReactNode[] | React.ReactNode;
  fillTemplateProgress?: string;
  isSaveButtonActive: boolean;
  isSaveButtonLoading: boolean;
  iconButtons: any[];
  secondButtonJsx?: React.ReactNode;
  isSecondButtonHidden?: boolean;

  websites: WebsitesState;
  websitesPages: WebsitePagesState;
  getCurrentStoreData: GetCurrentStoreData;
  getPageLoadStatus: any;
  setSettingsModalType: any;
  setIsSettingsModalVisible: any;
}
const PageBottomBar = (props: Props) => {
  const {
    fillTemplateProgress,
    isSaveButtonActive,
    isSaveButtonLoading,
    buttons,
    isButtonHidden,
    isHidden,
    isSecondButtonHidden,
    secondButtonJsx,
  } = props;
  if (fillTemplateProgress === "inProgress") {
    return <FillTemplateProgressIndicator />;
  }
  if (isHidden) return null;

  return (
    <div className="editor__bottom-bar">
      <div className="editor__bottom-bar-left">
        {props.iconButtons.map((button, i) => {
          return (
            <Tooltip
              title={!button.isLoading ? button.tooltip : ""}
              placement="top"
              mouseLeaveDelay={0}
              mouseEnterDelay={0.25}
              transitionName=""
              overlayClassName="nav-sidebar__button-tooltip"
              key={i}
            >
              {button.buttonJsx && button.buttonJsx}
              {!button.buttonJsx && (
                <button
                  className={classNames("editor__bottom-bar-button", {
                    "is-loading": button.isLoading,
                  })}
                  onClick={() => {
                    if (button.onClick) {
                      button.onClick();
                    }
                  }}
                  disabled={button.isLoading}
                >
                  {button.isLoading && <LoaderAnimated />}
                  {!button.isLoading && button.icon}
                </button>
              )}
            </Tooltip>
          );
        })}
      </div>
      {!isButtonHidden && <div className="editor__bottom-bar-divider" />}
      {!isButtonHidden && (
        <div
          className={
            "editor__save_button_box " +
            (isSaveButtonActive &&
            !isSaveButtonLoading &&
            fillTemplateProgress !== "inProgress"
              ? " editor__save_button_box--accent "
              : "")
          }
        >
          {buttons}
        </div>
      )}
      {!isSecondButtonHidden && secondButtonJsx}
    </div>
  );
};

const mapStateToProps = (props) => {
  return {
    websites: props.websites,
    websitesPages: props.websitesPages,
  };
};
export default connect(mapStateToProps, {
  getCurrentStoreData,
  getPageLoadStatus,
  setSettingsModalType,
  setIsSettingsModalVisible,
})(PageBottomBar);
